export default __webpack_public_path__ + "static/media/NDTV_Profit.6c5583be.png";